import {action, makeAutoObservable, observable, runInAction} from "mobx";
import {inject, injectable} from "inversify";
import type {IJSONProvider} from "data/providers/json/json.provider";
import {Bindings} from "data/constants/bindings";
import {ContestStatus, GameStatus} from "data/enums";

export interface IContest {
	id: number;
	gameFeedId: string;
	name: string;
	startDate: string | null;
	endDate: string | null;
	status: ContestStatus;
	gameId: number;
	homeSquadId: number;
	awaySquadId: number;
	homeSquadScore: number;
	awaySquadScore: number;
	winnerId: number | null;
	opponentWinnerId: number | null;
	inning: number | null;
	inningState: string | null;
	gameStartDate: string;
	gameStartTimeTBD: boolean;
	gameStatus: GameStatus;
	roundId: number;
	totalVotes: number | null;
}

export interface IContestsStore {
	get getIsLoading(): boolean;

	get list(): IContest[];

	// get sortedList(): IContest[];
	//
	// get sortedListByDate(): IContest[];

	getContestById(contestId: number): IContest | undefined;

	getContestByFeedId(gameFeedId: number): IContest | undefined;

	fetchContest(): Promise<void>;
}

@injectable()
export class ContestsStore implements IContestsStore {
	@observable private _isLoading: boolean = false;

	constructor(@inject(Bindings.JSONProvider) private _jsonProvider: IJSONProvider) {
		makeAutoObservable(this);
	}

	@observable private _list: IContest[] = [];

	get list() {
		return this._list;
	}

	// get sortedList() {
	// 	const liveContest = this._list.filter((contest) => contest.status === ContestStatus.LIVE);
	// 	const scheduledContest = this._list.filter(
	// 		(contest) => contest.status === ContestStatus.SCHEDULED
	// 	);
	// 	const resultedContest = this._list.filter(
	// 		(contest) => contest.status === ContestStatus.RESULTED
	// 	);
	//
	// 	return concat(liveContest, scheduledContest, resultedContest);
	// }
	//
	// get sortedListByDate() {
	// 	return orderBy(this._list, ["startDate"], ["desc"]);
	// }

	get getIsLoading(): boolean {
		return this._isLoading;
	}

	getContestById(contestId: number): IContest | undefined {
		return this._list.find((contest) => contest.id === contestId);
	}

	getContestByFeedId(gameFeedId: number): IContest | undefined {
		return this._list.find((contest) => Number(contest.gameFeedId) === gameFeedId);
	}

	@action
	async fetchContest() {
		const {data} = await this._jsonProvider.contests();

		runInAction(() => {
			this._list = data;
		});
	}
}
